export default __webpack_public_path__ + "static/media/new-light.04cdbd5a.svg";